import { isBrowser } from '@shared/utils-universal/is-browser';

export const scrollTop = () => {
  if (isBrowser()) {
    window.scrollTo(0, 0);
  }
};

export const scrollTopSmooth = (position = 0) => {
  window.scrollTo({
    top: position,
    behavior: 'smooth',
  });
};

export const scrollToPositionNotSmooth = (position: number) => {
  window.scrollTo({
    top: position,
    behavior: 'auto',
  });
};

export const scrollToStickySearchControls = () => {
  const header = document.getElementById('global-header-container');
  const headerRect = header?.getBoundingClientRect();
  const isVisible = headerRect
    ? headerRect?.top < window.innerHeight && headerRect?.bottom > 0
    : false;
  const headerHeight = headerRect?.height || 0;

  if (!isVisible) {
    scrollToPositionNotSmooth(headerHeight - 0.5);
  }
};

export const scrollByPriceComparisonCard = (index: number) => {
  const priceComparisonList = document.getElementById(
    `price-comparison-list-${index}`,
  );
  const priceComparisonListRect = priceComparisonList?.getBoundingClientRect();
  const isFullyVisible = priceComparisonListRect
    ? priceComparisonListRect?.top >= 0 &&
      priceComparisonListRect?.bottom <= window.innerHeight
    : true;
  const listHeight = priceComparisonListRect?.height || 0;

  if (!isFullyVisible) {
    window.scrollBy({
      top: listHeight,
      behavior: 'smooth',
    });
  }
};
